import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Menu, ChevronDown, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useCart } from '@/contexts/CartContext';

export default function Header({ onMenuToggle }) {
  const { user } = useAuth();
  const { cartCount, fetchCart } = useCart();
  const { logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => { fetchCart(); }, [user, fetchCart]);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogout = async () => {
    await logout();
    setDropdownOpen(false);
    navigate('/');
  };

  return (
    <header className="app-header" data-testid="app-header">
      <div className="header-left" onClick={onMenuToggle} data-testid="menu-toggle-btn">
        <Menu size={24} />
        <span>MENU</span>
      </div>
      <div className="header-right">
        <button className="cart-btn" onClick={() => navigate(user ? '/cart' : '/login')} data-testid="cart-btn">
          <ShoppingCart />
          {cartCount > 0 && <span className="cart-badge" data-testid="cart-badge">{cartCount}</span>}
        </button>
        {user && user !== false ? (
          <div ref={dropdownRef} style={{ position: 'relative' }}>
            <button className="user-menu-btn" onClick={() => setDropdownOpen(!dropdownOpen)} data-testid="user-menu-btn">
              <User size={18} />
              {user.name?.split(' ')[0]}
              <ChevronDown size={14} />
            </button>
            {dropdownOpen && (
              <div className="user-dropdown" data-testid="user-dropdown">
                <Link to="/orders" onClick={() => setDropdownOpen(false)} data-testid="my-orders-link">My Orders</Link>
                <Link to="/wishlist" onClick={() => setDropdownOpen(false)} data-testid="wishlist-link">Wishlist</Link>
                {user.role === 'admin' && (
                  <Link to="/admin" onClick={() => setDropdownOpen(false)} data-testid="admin-link">Admin Panel</Link>
                )}
                <button className="logout-btn" onClick={handleLogout} data-testid="logout-btn">Logout</button>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="login-link" data-testid="login-link">Login</Link>
        )}
      </div>
    </header>
  );
}
